import {
  LayoutDashboard,
  Users,
  Settings,
  Building2,
  Stethoscope,
  ClipboardList,
  Video,
  FileText,
  Pill,
  Tags,
  QrCode,
  Phone,
} from "lucide-react";
import type { NavItem } from "./types";

export const navItems: NavItem[] = [
  { name: "Dashboard", icon: LayoutDashboard, path: "/dashboard" },
  // Customers
  { name: "Organizations", icon: Building2, path: "/organizations", section: "Customers" },
  { name: "Users", icon: Users, path: "/users", section: "Customers" },
  { name: "Frontline", icon: Phone, path: "/frontline", section: "Frontline" },
  // Content
  { name: "Specialities", icon: Stethoscope, path: "/specialities", section: "Content" },
  { name: "QR Codes", icon: QrCode, path: "/qr-codes", section: "Content" },
  // Seed Content
  { name: "Condition Groups", icon: Tags, path: "/condition-lookup-groups", section: "Seed Content" },
  { name: "Conditions", icon: ClipboardList, path: "/conditions", section: "Seed Content" },
  { name: "Videos", icon: Video, path: "/seed-videos", section: "Seed Content" },
  { name: "Resources", icon: FileText, path: "/seed-resources", section: "Seed Content" },
  { name: "Prescriptions", icon: Pill, path: "/seed-prescriptions", section: "Seed Content" },
  // System
  { name: "Settings", icon: Settings, path: "/settings", section: "System" },
];

// Utility function to group items by section
export const groupItemsBySection = (items: NavItem[]) => {
  const sections: Record<string, NavItem[]> = {};
  const mainItems: NavItem[] = [];
  const sectionOrder: string[] = [];
  
  items.forEach(item => {
    if (item.section) {
      if (!sections[item.section]) {
        sections[item.section] = [];
        sectionOrder.push(item.section);
      }
      sections[item.section].push(item);
    } else {
      mainItems.push(item);
    }
  });
  
  return { mainItems, sections, sectionOrder };
};
